export default "__VITE_ASSET__08c5ee8f__"